import { Injectable, EventEmitter, Output } from '@angular/core';
import { orderBy } from 'lodash';

import { SortableComponent } from './sortable-component/sortable.component';


@Injectable()
export class SortableService {

  @Output() sortData: EventEmitter<any> = new EventEmitter<any>();

  model: any = {
    data: [],
    sortableFields: [],
    currentSortableField: '',
    backendSorting: false,
  };

  init(data: any[], backendSorting: boolean) {
    this.model.data = data;
    this.model.backendSorting = backendSorting;
  }

  setData(data: any[]) {
    this.model.data = data;
  }

  add(sortableComponent: SortableComponent) {
    this.model.sortableFields.push(sortableComponent);
  }

  sortBy(property: string, isAsc: boolean) {
    this.model.currentSortableField = property;
    const order: Array<boolean | 'asc' | 'desc'> = isAsc ? ['asc'] : ['desc'];
    if (this.model.backendSorting) {
      this.sortData.emit({
        sortCol: this.model.currentSortableField,
        sortDir: order[0],
      });
    } else {
      this.model.data = orderBy(this.model.data, [this.model.currentSortableField], order);
      this.sortData.emit(this.model.data);
    }
    this.setActive(property);
  }

  setActive(property: string) {
    this.model.sortableFields.forEach((item: SortableComponent) => {
      item.setActive(item.sortableField === property);
    });
  }

  reset() {
    this.model.data = [];
    this.model.sortableFields = [];
  }
}
